import { BaseButtonProps } from "@/type/sifPageTypes";

type SecondaryButtonProps = BaseButtonProps;

export function SIFSecondaryButton({
  children,
  onClick,
  disabled = false,
  secondaryBg = true,
  maxWidth = true,
  buttonSize = "big",
  display = "block",
  className = "",
  ariaLabel,
}: SecondaryButtonProps) {
  return (
    <button
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={`group ${display === "block" ? "block" : "flex items-center justify-center gap-1.5"} ${buttonSize === "big" ? "text-sm sm:text-base py-3 sm:py-3.5 rounded-xl" : "text-2xs sm:text-sm py-2 rounded-2lg"} ${secondaryBg ? "bg-white/25 hover:bg-transparent" : "bg-transparent hover:bg-white/25"} ${maxWidth ? "w-full xs:max-w-56" : "w-full"} font-semibold text-white leading-1.5! border border-white transition duration-300 disabled:opacity-50 disabled:pointer-events-none ${className}`}
    >
      {children}
    </button>
  );
}
